export default {
    dashboard: {
        totalWordsGenerated: 'Antall ord generert totalt',
        wordsPerDay: 'Ord/dag',
        content: 'Innhold',
        date: 'Dato',
        variationCount: 'Antall Variasjoner',
        transactionId: 'Transaksjons-ID',
        totalWordsCount: 'Totalt Antall Ord',
        action: 'Handling',
        goTo: 'Gå til',
        viewMore: 'Vis mer',
        showLess: 'Vis mindre',
        tabImage: 'Bilde',
        tabText: 'Tekst',
        dashboardSubtitle: 'Administrer ditt AI-genererte innhold',
        type: 'Type',
    },
};
